import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Post } from '../models/post.model';
import { Setting } from '../models/setting.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Apidata {
   apiUrl:string =environment.apiUrl;

  constructor(private http : HttpClient){}

  public loadSettings():Observable<any>{
    return this.http.get<any>(`${this.apiUrl}/api/v1/settings`);
  }

   public loadSponsors():Observable<any>{
    return this.http.get<any>(`${this.apiUrl}/api/v1/sponsors`);
  }

  public loadHero():Observable<any>{
    return this.http.get(`${this.apiUrl}/api/v1/posts?category=4`);
  }

  public loadSlides():Observable<any>{
    return this.http.get(`${this.apiUrl}/api/v1/sliders`);
  }



  public loadNews():Observable<any>{
    return this.http.get<Post[]>(`${this.apiUrl}/api/v1/posts?category=1`);
  }

  public loadEvents():Observable<any>{
    return this.http.get<Post[]>(`${this.apiUrl}/api/v1/posts?category=2`);
  }
  public loadCommuniques():Observable<any>{
    return this.http.get<Post[]>(`${this.apiUrl}/api/v1/posts?category=3`);
  }
  //post/lastest
   public loadLastestPosts():Observable<any>{
    return this.http.get<Post[]>(`${this.apiUrl}/api/v1/post/lastest`);
  }
}
